var _defs, _circle, _circle2, _circle3, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #042b62;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 127.88,
    cy: 269.95,
    r: 68.88
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 127.88,
    cy: 538.12,
    r: 68.88
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 127.88,
    cy: 810.5,
    r: 68.88
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 265.08,
    y: 202.03,
    width: 753.97,
    height: 133.15,
    rx: 53.29,
    ry: 53.29
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 266.06,
    y: 468.34,
    width: 753.97,
    height: 133.15,
    rx: 53.29,
    ry: 53.29
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 267.03,
    y: 734.65,
    width: 753.97,
    height: 133.15,
    rx: 53.29,
    ry: 53.29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankList);
export default __webpack_public_path__ + "static/media/Bank_list.871961215fe0feff01f563802b59029f.svg";
export { ForwardRef as ReactComponent };